// 9fbef606107a605d69c0edbcd8029e5d

export const ARROW_VISIBLE_BP = {
  1200: 2,
  1400: 3,
  1670: 4,
  1970: 5,
  2250: 6,
  2500: 7,
  2800: 8,
  default: 2,
};
export const SLIDES_TO_SCROLL_BP = {
  1200: 3,
  1400: 4,
  1670: 5,
  1970: 6,
  2250: 7,
  2500: 8,
  2800: 9,
  default: 3,
};

export const calculateBreakPointByWidth = ([innerWidth]) => {
  if (innerWidth < 1400) return 1200;
  if (innerWidth < 1670) return 1400;
  if (innerWidth < 1970) return 1670;
  if (innerWidth < 2250) return 1970;
  if (innerWidth < 2500) return 2250;
  if (innerWidth < 2800) return 2500;
  if (innerWidth >= 2800) return 2800;
  return 'default';
};
